import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { FileText, ClipboardList, FileSignature, Truck, Eye, Loader2 } from "lucide-react";

const ICONS = { operations: ClipboardList, client_po: FileSignature, somcore_po: FileText, logistics: Truck };
const fmtD = (d) => (d ? new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "");

const openFile = async (url) => {
  try {
    const res = await api.get(url, { responseType: "blob" });
    window.open(window.URL.createObjectURL(new Blob([res.data], { type: res.headers["content-type"] })), "_blank");
  } catch (e) { toast.error(apiError(e)); }
};

function Section({ s }) {
  const Icon = ICONS[s.key] || FileText;
  return (
    <div className="rounded-xl border border-border bg-white p-5" data-testid={`order-docs-${s.key}`}>
      <div className="mb-3 flex items-center gap-2">
        <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-[#E6ECF5] text-[#1B4383]"><Icon className="h-4 w-4" /></span>
        <h3 className="font-heading text-sm font-bold text-slate-800">{s.title}</h3>
        <span className="rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-semibold text-slate-500">{s.items.length}</span>
      </div>
      {s.items.length ? (
        <div className="divide-y divide-border">
          {s.items.map((f, i) => (
            <div key={`${f.url}-${i}`} className="flex flex-wrap items-center justify-between gap-2 py-2.5" data-testid={`order-doc-${s.key}-${i}`}>
              <div className="min-w-0">
                <div className="break-all text-sm font-medium text-slate-800">{f.filename}</div>
                <div className="text-[11px] text-muted-foreground">{[f.label, f.by, fmtD(f.at)].filter(Boolean).join(" · ")}</div>
              </div>
              <button onClick={() => openFile(f.url)} className="inline-flex items-center gap-1 rounded-md border border-border px-2.5 py-1 text-xs font-semibold text-[#1B4383] hover:bg-[#E6ECF5]" data-testid={`order-doc-open-${s.key}-${i}`}><Eye className="h-3.5 w-3.5" />Open</button>
            </div>
          ))}
        </div>
      ) : <div className="rounded-lg border border-dashed border-border p-4 text-center text-xs text-muted-foreground">No documents yet.</div>}
    </div>
  );
}

export const OrderDocuments = ({ orderId }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get(`/orders/${orderId}/documents`).then((r) => setData(r.data)).catch((e) => toast.error(apiError(e)));
  }, [orderId]);
  if (!data) return <div className="flex items-center gap-2 p-6 text-sm text-muted-foreground"><Loader2 className="h-4 w-4 animate-spin" />Loading documents…</div>;
  return <div className="space-y-4" data-testid="order-documents">{data.sections.map((s) => <Section key={s.key} s={s} />)}</div>;
};
